// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../src/assets/UI_BG_pagoni-01.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_root__pI3a- {
  /*}:root {*/
  width: 100%;
  height: 100%;
}

.Login_body__wfSEx {
  /* body */
  /*justify-content: center;

  align-items: center;

  display: flex;
  flex-direction: column;*/

  height: 100%;
  /*border: 1px solid black;*/

  /*background: seagreen; url("../../../../src/assets/city.avif");*/
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

.Login_body_root__44-ur {
  /* body #root { */
  width: 100%;
  height: 100%;
}

.Login_container__MBpaJ {
  max-width: unset;
  width: 100%;
  height: 100%;
}

.Login_horizontalMargins__MM-\\+y {
  padding-left: 75px;
  padding-right: 75px;
}

.Login_expand-width__6F3Vc {
  /* width: 35%;
  margin-right: 70px;*/
}

.Login_section__Ow4wc {
  justify-content: center;
  width: 100%;
  height: 100%;
}

.Login_floatingCircle__484gt {
  position: absolute !important;
  top: -75px !important;
  z-index: 100;

  display: flex;
  justify-content: center;
}

.Login_profile__HKAbz {
  height: 100px;
  width: 100px;
  border-radius: 50px;
  background-color: white;

  box-shadow: 0px 0.5rem 0.3rem 3px rgba(0, 0, 0, 0.15);

  display: flex;
  justify-content: center;
  align-items: center;
}

.Login_topMarginForFloating__wv4a4 {
  margin-top: 90px;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT;;;;;0BAKwB;;EAExB,YAAY;EACZ,2BAA2B;;EAE3B,iEAAiE;EACjE,mDAAgE;EAChE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;sBACoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,YAAY;;EAEZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;;EAEvB,qDAAqD;;EAErD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".root {\n  /*}:root {*/\n  width: 100%;\n  height: 100%;\n}\n\n.body {\n  /* body */\n  /*justify-content: center;\n\n  align-items: center;\n\n  display: flex;\n  flex-direction: column;*/\n\n  height: 100%;\n  /*border: 1px solid black;*/\n\n  /*background: seagreen; url(\"../../../../src/assets/city.avif\");*/\n  background: url(\"../../../../../src/assets/UI_BG_pagoni-01.png\");\n  background-size: cover;\n  background-position: center;\n}\n\n.body_root {\n  /* body #root { */\n  width: 100%;\n  height: 100%;\n}\n\n.container {\n  max-width: unset;\n  width: 100%;\n  height: 100%;\n}\n\n.horizontalMargins {\n  padding-left: 75px;\n  padding-right: 75px;\n}\n\n.expand-width {\n  /* width: 35%;\n  margin-right: 70px;*/\n}\n\n.section {\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.floatingCircle {\n  position: absolute !important;\n  top: -75px !important;\n  z-index: 100;\n\n  display: flex;\n  justify-content: center;\n}\n\n.profile {\n  height: 100px;\n  width: 100px;\n  border-radius: 50px;\n  background-color: white;\n\n  box-shadow: 0px 0.5rem 0.3rem 3px rgba(0, 0, 0, 0.15);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.topMarginForFloating {\n  margin-top: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Login_root__pI3a-`,
	"body": `Login_body__wfSEx`,
	"body_root": `Login_body_root__44-ur`,
	"container": `Login_container__MBpaJ`,
	"horizontalMargins": `Login_horizontalMargins__MM-+y`,
	"expand-width": `Login_expand-width__6F3Vc`,
	"section": `Login_section__Ow4wc`,
	"floatingCircle": `Login_floatingCircle__484gt`,
	"profile": `Login_profile__HKAbz`,
	"topMarginForFloating": `Login_topMarginForFloating__wv4a4`
};
export default ___CSS_LOADER_EXPORT___;
